import { useQuery } from "@apollo/client";

import { GqlProjectUserGetAllUsersParams, gql } from "~/__generated__";
import useCacheFilterOptions from "~/modules/app/hooks/useCacheFilterOptions";

import { GqlProjectMetadata } from "./useMeGetProjectInfoQuery";

export const PROJECT_USER_GET_ALL_WITH_ACCESS_TO_PROJECT = gql(`
    query ProjectUserGetAllWithAccessToProject($projectId: ID!, $params: GqlProjectUserGetAllUsersParams!) {
        projectUserGetAllWithAccessToProject(projectId: $projectId, params: $params) {
        queryInfo {
            filterOptions {
                ... on GqlFilterOptionText {
                    filterType
                    label
                    key
                }
                ... on GqlFilterOptionSelect {
                    filterType
                    label
                    key
                    options {
                        label
                        value
                    }
                }
                ... on GqlFilterOptionMultiSelect {
                    filterType
                    label
                    key
                    dataModel
                }
                ... on GqlFilterOptionBoolean {
                    filterType
                    label
                    key
                }
            }
            sortableColumns
            paginationOption {
              page
              total
            }
        }
        data {
            id
            projectId
            roleId
            userId
            user {
              id
              firstName
              lastName
              email
              phone
              profilePictureMedia {
                id
                url
              }
            }
            projectRole {
              name
            }
          }
        }
    }
`);

export default function useProjectUserGetAllWithAccessToProject(
    params: GqlProjectUserGetAllUsersParams,
    project: GqlProjectMetadata,
) {
    const { data, loading, error } = useQuery(PROJECT_USER_GET_ALL_WITH_ACCESS_TO_PROJECT, {
        variables: {
            params,
            projectId: project?.id,
        },
        errorPolicy: "all",
    });

    const queryInfo = data?.projectUserGetAllWithAccessToProject.queryInfo;
    const [filterOptions] = useCacheFilterOptions(queryInfo?.filterOptions);

    return {
        loading,
        error,
        totalRows: queryInfo?.paginationOption.total || 0,
        sortableColumns: queryInfo?.sortableColumns,
        filterOptions: filterOptions,
        data: data?.projectUserGetAllWithAccessToProject?.data,
    };
}
